import axios from "axios";
 
// Base URL for .concat usage
const BaseUrl = "https://admin.dollarempirellc.com";
 
// JWT token as string
let token = window.localStorage.getItem("token") || "";
 
// Remove quotes if accidentally stored as JSON string
if (token.startsWith('"') && token.endsWith('"')) {
  token = token.slice(1, -1);
}
 
// User language
const userLang = window.localStorage.getItem("user_lang") || "en";
 
// Axios instances
export const PostUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "post",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
export const GetUrl = axios.create({
  baseURL: `${BaseUrl}/api`,
  method: "get",
  headers: {
    "Accept-Language": userLang,
    Authorization: token ? `Bearer ${token}` : "",
  },
});
 
export default BaseUrl;